/**
 * Taste preview — Figma Design System `Taste preview` (3448:113123): Kind = Style |
 * Color | Brand. Up to four items, then a "+N" cell.
 */

export type FairTastePreviewKind = 'style' | 'color' | 'brand'

export interface FairTastePreviewItem {
  id: number | string
  name: string
  /** Style photo or brand logo. */
  image?: string | null
  /** Color swatch. */
  hex?: string | null
}

/** Four items fit; the fifth place becomes "+N". */
export const FAIR_TASTE_PREVIEW_MAX = 4

export function fairTastePreviewSlice<T>(
  items: readonly T[],
  max: number = FAIR_TASTE_PREVIEW_MAX,
): { shown: T[]; more: number } {
  const limit = Math.max(0, max)
  return { shown: items.slice(0, limit), more: Math.max(0, items.length - limit) }
}
